import {
  hasServiceLevelFeedbackContent,
  sanitizeServiceLevelFeedbackContent,
  SERVICE_LEVEL_FEEDBACK_MAX_AUTHOR_NAME_LENGTH,
  SERVICE_LEVEL_FEEDBACK_MAX_CONTENT_LENGTH,
  SERVICE_LEVEL_FEEDBACK_MAX_DEPARTMENT_LENGTH,
} from './serviceLevelFeedbackSanitize'

export type ServiceLevelFeedbackSubmitPayload = {
  department: string
  author_name: string
  content: string
}

export class ServiceLevelFeedbackSubmitError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ServiceLevelFeedbackSubmitError'
  }
}

export const validateServiceLevelFeedbackPayload = (
  payload: ServiceLevelFeedbackSubmitPayload,
): ServiceLevelFeedbackSubmitPayload => {
  const department = (payload.department || '').trim()
  const author_name = (payload.author_name || '').trim()
  const content = sanitizeServiceLevelFeedbackContent(payload.content || '')

  if (!department) {
    throw new ServiceLevelFeedbackSubmitError('所属部署を入力してください')
  }
  if (!author_name) {
    throw new ServiceLevelFeedbackSubmitError('名前を入力してください')
  }
  if (!hasServiceLevelFeedbackContent(content, { alreadySanitized: true })) {
    throw new ServiceLevelFeedbackSubmitError('質問・要望内容を入力してください')
  }
  if (department.length > SERVICE_LEVEL_FEEDBACK_MAX_DEPARTMENT_LENGTH) {
    throw new ServiceLevelFeedbackSubmitError(
      `所属部署は${SERVICE_LEVEL_FEEDBACK_MAX_DEPARTMENT_LENGTH}文字以内で入力してください`,
    )
  }
  if (author_name.length > SERVICE_LEVEL_FEEDBACK_MAX_AUTHOR_NAME_LENGTH) {
    throw new ServiceLevelFeedbackSubmitError(
      `名前は${SERVICE_LEVEL_FEEDBACK_MAX_AUTHOR_NAME_LENGTH}文字以内で入力してください`,
    )
  }
  if (content.length > SERVICE_LEVEL_FEEDBACK_MAX_CONTENT_LENGTH) {
    throw new ServiceLevelFeedbackSubmitError(
      `質問・要望内容は${SERVICE_LEVEL_FEEDBACK_MAX_CONTENT_LENGTH}文字以内で入力してください`,
    )
  }

  return { department, author_name, content }
}

/**
 * Directus Public ロールの create 権限で投稿する（is_confirmed は送らない）
 */
export const submitServiceLevelFeedback = async (
  payload: ServiceLevelFeedbackSubmitPayload,
): Promise<string | number> => {
  const validated = validateServiceLevelFeedbackPayload(payload)

  const created = await $core.$directusSdk
    .items('yhc_service_level_feedbacks')
    .createOne({
      department: validated.department,
      author_name: validated.author_name,
      content: validated.content,
    })

  if (created === null || created === undefined || created.id == null) {
    throw new ServiceLevelFeedbackSubmitError('投稿に失敗しました')
  }

  return created.id
}
